var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.425 9.77971C15.3177 9.77971 16.852 8.24541 16.852 6.35275C16.852 4.46009 15.3177 2.92578 13.425 2.92578C11.5324 2.92578 9.99805 4.46009 9.99805 6.35275C9.99805 8.24541 11.5324 9.77971 13.425 9.77971Z",
    fill: "#848AA0",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4238 9.78C15.3165 9.78 16.8508 8.2457 16.8508 6.35304C16.8508 4.88895 15.9327 3.63931 14.6408 3.14844",
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1055 14.5939C19.7818 15.7103 18.6499 17.8637 16.6358 17.8637H9.07238C7.05831 17.8637 5.92639 15.7103 7.60269 14.5939C9.10629 13.5924 10.912 13.0088 12.8541 13.0088C14.7962 13.0088 16.6019 13.5924 18.1055 14.5939Z",
    fill: "#848AA0",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66011 9.10049C9.71173 9.10049 11.3749 7.43732 11.3749 5.38569C11.3749 3.33407 9.71173 1.6709 7.66011 1.6709C5.60848 1.6709 3.94531 3.33407 3.94531 5.38569C3.94531 7.43732 5.60848 9.10049 7.66011 9.10049Z",
    fill: "#848AA0",
    fillOpacity: 0.3,
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3468 14.3203C15.1639 15.5305 13.9369 17.8647 11.7537 17.8647H3.55501C1.37178 17.8647 0.144788 15.5305 1.96188 14.3203C3.59177 13.2347 5.54918 12.6021 7.65435 12.6021C9.75952 12.6021 11.7169 13.2347 13.3468 14.3203Z",
    fill: "#848AA0",
    fillOpacity: 0.3,
    stroke: "#848AA0",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 17.864H16.634C18.6481 17.864 19.78 15.7107 18.1037 14.5942C17.6408 14.2859 17.1493 14.0172 16.634 13.793",
    stroke: "#848AA0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleDark);
export default __webpack_public_path__ + "static/media/people-dark.fc7f0e2295db70b6fe9dc2f4b2684772.svg";
export { ForwardRef as ReactComponent };